export enum Scope1FieldsEnums {
    NATURAL_GAS = "natural_gas"
  }